import { useEffect, useState, type ReactNode } from "react";
import { Navigate } from "react-router-dom";

const MOBILE_QUERY = "(max-width: 767px)";

export function MobileRundgangGuard({ children }: { children: ReactNode }) {
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(MOBILE_QUERY).matches);

  useEffect(() => {
    const query = window.matchMedia(MOBILE_QUERY);
    const update = () => setIsMobile(query.matches);
    query.addEventListener("change", update);
    return () => query.removeEventListener("change", update);
  }, []);

  if (isMobile) return <Navigate to="/rundgang" replace />;
  return <>{children}</>;
}